import BaseButton from "shared/components/inputs/button/BaseButton";
import { COLOR_VALUES } from "shared/config/colors";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    ${(props) =>
        props.disabled &&
        css`
            cursor: not-allowed;
        `}
    ${(props) =>
        props.fullWidth &&
        css`
            width: 100%;
        `}
`;

export const StyledSecondaryButton = styled(BaseButton)`
    display: inline-flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-shadow: 0 0 0px 1px ${COLOR_VALUES.Black} inset;
    color: ${COLOR_VALUES.Black} !important; /* !important to override css reboot */
    text-decoration: none !important; /* !important to override css reboot */
    padding: ${({ $reducePadding, $small, $mediumSmall }) => {
        if ($small) return "6px 16px";
        if ($mediumSmall) return "10px 24px";
        if ($reducePadding) return "14px 16px";
        return "14px 48px";
    }};
    min-height: ${({ $small, $mediumSmall }) => {
        if ($small) return "32px";
        if ($mediumSmall) return "40px";
        return "48px";
    }};
    width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "inherit")};

    ${(props) =>
        props.disabled
            ? css`
                  pointer-events: none;
                  color: ${COLOR_VALUES.Gray_3};
                  box-shadow: 0 0 0px 1px ${COLOR_VALUES.Gray_3} inset;
              `
            : css`
                  &:hover {
                      box-shadow: 0 0 0px 2px ${COLOR_VALUES.Gray_6} inset;
                  }

                  &:active {
                      box-shadow: 0 0 0px 2px ${COLOR_VALUES.Black} inset;
                  }
              `}
`;
